export const DriverLicenseState = {
  FL: 'FL'
};

export const enum LicenseRules {
  NumberLength = 13
}

export const enum LicenseType {
  CriminalBackgroundCheck = 17
}

export const enum CategoryTypeLicense {
  Driver = 2
}



// WEBPACK FOOTER //
// ./src/app/core/enums/driver-license.enum.ts